import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';

import { Checkbox } from 'ui-components/components/checkbox';
import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { SPEEDSHIP_TERMS_PATH } from '../../../../routes/constants';
import { getErrorMessage } from '../../../../validation/utilities';
import type { ValidationError } from '../../../../validation/validation-error';
import { messages } from './messages';
import styles from './terms-section.module.less';

type TermsSectionProps = {
  isAccepted: boolean;
  isDisabled: boolean;
  error?: ValidationError;
  onAcceptChange: (accepted: boolean) => void;
};

export const TermsSection = ({ isAccepted, isDisabled, error, onAcceptChange }: TermsSectionProps) => {
  const intl = useIntl();

  const handleChange = useCallback(() => {
    onAcceptChange(!isAccepted);
  }, [isAccepted, onAcceptChange]);

  const errorMessage = getErrorMessage(error);

  return (
    <FlexColumn className={styles.termsContainer} gap={Gap.Space4}>
      <Checkbox checked={isAccepted} disabled={isDisabled} onChange={handleChange}>
        <Text
          className={styles.termsText}
          formattedMessageValues={{
            termsLink: (
              <Button className={styles.termsLink} href={SPEEDSHIP_TERMS_PATH} theme={THEME_CONSTANTS.link}>
                {intl.formatMessage(messages.termsLinkText)}
                <FontAwesomeIcon className={styles.termsLinkIcon} icon={faArrowUpRightFromSquare} />
              </Button>
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.termsCheckboxLabel}
        />
      </Checkbox>
      {errorMessage && <InlineMessage type={INLINE_MESSAGE_TYPES.error}>{errorMessage}</InlineMessage>}
    </FlexColumn>
  );
};
